import { namespacer } from 'helpers'

const namespace = namespacer('MODAL')

export const OPEN_MODAL = namespace('OPEN_MODAL')
export const CLOSE_MODAL = namespace('CLOSE_MODAL')
